const StatusList = [
    "active",
    "deactivate",
    'require_payment',
    "expiry"
];
export default StatusList;
